import { NgModule } from "@angular/core";
import { SuggestionProductModalComponent } from "./suggestion-product-modal.component";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { HeroModule } from "../hero/hero.module";
import { NewHeroModule } from "../new-hero/new-hero.module";

@NgModule({
    imports: [
        CommonModule,
        
        MatDialogModule,
        MatProgressSpinnerModule,
        HeroModule,
        NewHeroModule,
        MatButtonModule,
        MatIconModule
    ],
    exports: [
        SuggestionProductModalComponent
    ],
    providers: [
    ],
    declarations: [
        SuggestionProductModalComponent
    ]
})

export class SuggestionProductModalModule { }
